import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faUsers, faGlobe, faMap, faCheckSquare, faUniversity} from '@fortawesome/free-solid-svg-icons'
import { faMusic } from '@fortawesome/free-solid-svg-icons'
import { faCross } from '@fortawesome/free-solid-svg-icons'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { faBook } from '@fortawesome/free-solid-svg-icons'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { faLanguage } from '@fortawesome/free-solid-svg-icons'
import { faGenderless } from '@fortawesome/free-solid-svg-icons'
import { faMars } from '@fortawesome/free-solid-svg-icons'
import { faVenus } from '@fortawesome/free-solid-svg-icons'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons'
import { faMapMarker} from '@fortawesome/free-solid-svg-icons'
import { faQuestion} from '@fortawesome/free-solid-svg-icons'
import { faShare } from '@fortawesome/free-solid-svg-icons'
import { faGuitar} from '@fortawesome/free-solid-svg-icons'
import { faDotCircle} from '@fortawesome/free-solid-svg-icons'
import { faWarehouse} from '@fortawesome/free-solid-svg-icons'
import { faFingerprint} from '@fortawesome/free-solid-svg-icons'
import { faParagraph} from '@fortawesome/free-solid-svg-icons'
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons'
import { faTheaterMasks } from '@fortawesome/free-solid-svg-icons'
import { faStream } from '@fortawesome/free-solid-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { faMask } from '@fortawesome/free-solid-svg-icons'
import { faHistory } from '@fortawesome/free-solid-svg-icons'
import { faLandmark } from '@fortawesome/free-solid-svg-icons'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { faFireFlameSimple } from '@fortawesome/free-solid-svg-icons'
import { faDatabase } from '@fortawesome/free-solid-svg-icons'
import { faSignature } from '@fortawesome/free-solid-svg-icons'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { faPeopleArrows } from '@fortawesome/free-solid-svg-icons'
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { faBookBookmark } from "@fortawesome/free-solid-svg-icons";
import { faTag } from "@fortawesome/free-solid-svg-icons";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import {BTab, BTabs } from 'bootstrap-vue'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.js'
import 'vuetify/dist/vuetify.min.css'

import VueLayers from 'vuelayers'
import 'vuelayers/lib/style.css' // needs css-loader

Vue.use(VueLayers, {
  dataProjection: 'EPSG:4326',
});

// Add components globally
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('b-tabs', BTabs)
Vue.component('b-tab', BTab)

Vue.use(Vuetify)
Vue.use(Vuex)

library.add(faUser)
library.add(faUsers)
library.add(faMusic)
library.add(faCross)
library.add(faBriefcase)
library.add(faBook)
library.add(faCalendar)
library.add(faLanguage)
library.add(faGenderless)
library.add(faMars)
library.add(faVenus)
library.add(faPencilAlt)
library.add(faBirthdayCake)
library.add(faMapMarker)
library.add(faGlobe)
library.add(faMap)
library.add(faCheckSquare)
library.add(faUniversity)
library.add(faQuestion)
library.add(faShare)
library.add(faGuitar)
library.add(faDotCircle)
library.add(faWarehouse)
library.add(faFingerprint)
library.add(faParagraph)
library.add(faCalendarDay)
library.add(faTheaterMasks)
library.add(faStream)
library.add(faLink)
library.add(faMask)
library.add(faHistory)
library.add(faLandmark)
library.add(faAngleUp)
library.add(faEdit)
library.add(faFireFlameSimple)
library.add(faDatabase)
library.add(faSignature)
library.add(faInfoCircle)
library.add(faPeopleArrows)
library.add(faFile)
library.add(faBookBookmark)
library.add(faTag)
library.add(faUpRightFromSquare)
library.add(faQuoteLeft)
library.add(faCaretRight)
library.add(faCaretDown)

Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    // for Database.vue
    activeTabDatabase: 0,
    searchPersons: "",
    searchWorks: "",
    searchOrgs: "",
    searchPlaces: "",
    // for Work
    activeTabWork: 0,
    innerLink: ""
  }
})

new Vue({
  router,
  store: store,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app')
